export const global_breakpoint_md = {
  "name": "--pf-v5-global--breakpoint--md",
  "value": "768px",
  "var": "var(--pf-v5-global--breakpoint--md)"
};
export default global_breakpoint_md;